import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, isRef as _isRef, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608395d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "Modal_Content"
}
const _hoisted_2 = { class: "Modal_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Modal_Header_Title" }, "VAN強制ST", -1))
const _hoisted_4 = { class: "Modal_Main" }
const _hoisted_5 = { class: "Modal_Table" }
const _hoisted_6 = { class: "Modal_Table_Yoko" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌CD", -1))
const _hoisted_8 = { class: "Modal_Table_Yoko" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌名", -1))
const _hoisted_10 = { class: "Modal_Table_Yoko" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "Modal_Table_InputBikou" }, [
  /*#__PURE__*/_createTextVNode(" 強制"),
  /*#__PURE__*/_createElementVNode("br", { class: "Modal_Index" }),
  /*#__PURE__*/_createTextVNode("ステータス ")
], -1))
const _hoisted_12 = { class: "Modal_Table_InputBikou" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "error_text"
}
const _hoisted_15 = { class: "Modal_Table_Yoko" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("適用"),
  /*#__PURE__*/_createElementVNode("br", { class: "Modal_Index" }),
  /*#__PURE__*/_createTextVNode("期間")
], -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "Modal_Table_MukigenCheck" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_21 = {
  key: 0,
  class: "error_text"
}
const _hoisted_22 = { class: "Modal_Container_Btn" }
const _hoisted_23 = {
  key: 1,
  class: "Btn_Disabled",
  style: {"margin-left":"5px"}
}

import BtnGreen from "../../components/atoms/button/BtnGreen.vue";
import { ref } from "vue";
import type { SelectedProductType } from "../../views/EditProductStatus.vue";
import { useStore } from "vuex";
import axios from "axios";
import ModalWarningMessage from "./ModalWarningMessage.vue";
import BtnWhite from "../atoms/button/BtnWhite.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOrderSearchVan',
  props: {
  isVisible: {
    required: true,
    type: Boolean,
    default: false,
  },
  selectedProduct: {
    required: true,
    type: Object as () => SelectedProductType,
  },
},
  emits: ["close", "updateStatus"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore();

const selectedList = ref<{ value: number; statusName: string }[]>(
  store.getters["constant/getVanStatus"]
);
const selectedStatus = ref<{ value: number | null; statusName: string }>({
  value: props.selectedProduct.vanStatusId,
  statusName: String(props.selectedProduct.updateStatus),
});
let date_to = ref("");
let date_from = ref("");
let isMukigenChecked = ref(false);

// 初期表示設定
const showDeleteBtn = ref(false);
const initialDisplay = () => {
  // 適用期間
  if (props.selectedProduct.toUpdateStatusDate === "9999-12-31") {
    isMukigenChecked.value = true;
  }

  if (!isMukigenChecked.value) {
    date_from.value =
      props.selectedProduct.fromUpdateStatusDate === null
        ? ""
        : props.selectedProduct.fromUpdateStatusDate;
    date_to.value =
      props.selectedProduct.toUpdateStatusDate === null
        ? ""
        : props.selectedProduct.toUpdateStatusDate;
  }

  // 削除ボタンの表示制御
  if (
    props.selectedProduct.fromUpdateStatusDate !== null &&
    props.selectedProduct.toUpdateStatusDate !== null &&
    props.selectedProduct.updateStatus !== null
  ) {
    showDeleteBtn.value = true;
  }
};
initialDisplay();

const closeModal = (): void => {
  emit("close");
};

// 削除ボタン関連-----------------------------------------------------
const modalName = ref("");
const warningMessage = ref(
  "設定されているVAN強制STを削除します。\n実行してもよろしいですか？"
);
const deleteVanData = async () => {
  const sendData = {
    janCd: props.selectedProduct.janCd,
    updateStatus: null,
    fromUpdateStatusDate: null,
    toUpdateStatusDate: null,
    indefinite: false,
  };
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/syosi/vanStatus`,
      sendData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    modalName.value = "";
    emit("close");
    emit("updateStatus");
  } catch (error) {
    alert("VAN設定の削除に失敗しました");
    console.log(error);
  }
};

// 更新ボタン押下時の処理----------------------------------------------
const hasDateError = ref(false);
const dateErrorMessage = ref("");
const hasStatusError = ref(false);
const statusErrorMessage = ref("");
const updateST = async () => {
  // 表示期限バリデーション
  if (
    (date_to.value === "" || date_from.value === "") &&
    isMukigenChecked.value === false
  ) {
    dateErrorMessage.value = "表示期限を入力してください";
    hasDateError.value = true;
  } else if (
    date_from.value > date_to.value &&
    isMukigenChecked.value === false
  ) {
    dateErrorMessage.value = "終了日が開始日を下回っています";
    hasDateError.value = true;
  } else {
    dateErrorMessage.value = "";
    hasDateError.value = false;
  }
  // ステータスバリデーション
  if (selectedStatus.value.value === null) {
    statusErrorMessage.value = "ステータスを選択してください";
    hasStatusError.value = true;
  } else {
    statusErrorMessage.value = "";
    hasStatusError.value = false;
  }

  // エラーがない場合確定
  if (hasDateError.value === false && hasStatusError.value === false) {
    let dateFrom: string | null = "";
    let dateTo: string | null = "";
    if (isMukigenChecked.value === true) {
      const today = new Date();
      // 無期限の場合は、fromに今日の日付を入れる
      dateFrom = `${today.getFullYear()}-${("0" + (today.getMonth() + 1)).slice(
        -2
      )}-${("0" + today.getDate()).slice(-2)}`;
      dateTo = null;
    } else {
      dateFrom = date_from.value;
      dateTo = date_to.value;
    }

    const sendData = {
      janCd: props.selectedProduct.janCd,
      updateStatus: selectedStatus.value.value,
      fromUpdateStatusDate: dateFrom,
      toUpdateStatusDate: dateTo,
      indefinite: isMukigenChecked.value,
    };
    try {
      const res = await axios.patch(
        `${store.getters["getBaseUrl"]}/syosi/vanStatus`,
        sendData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      emit("close");
      emit("updateStatus");
    } catch (error) {
      console.log(error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (modalName.value === 'modalWarningMessage')
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (modalName.value = '')),
          onExecute: deleteVanData,
          message: warningMessage.value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (props.isVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "Modal",
          onClick: closeModal
        }))
      : _createCommentVNode("", true),
    (props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_font_awesome_icon, {
              onClick: closeModal,
              class: "Modal_Header_Close",
              icon: "xmark"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("tr", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(__props.selectedProduct.syosiCd), 1)
              ]),
              _createElementVNode("tr", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("td", null, _toDisplayString(__props.selectedProduct.title), 1)
              ]),
              _createElementVNode("tr", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    class: "Modal_Table_Select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedStatus.value.value) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedList.value, (data) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: data.value,
                        value: data.value
                      }, _toDisplayString(data.statusName), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedStatus.value.value]
                  ]),
                  (hasStatusError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(statusErrorMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "Modal_Table_InputDate",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(date_from) ? (date_from).value = $event : date_from = $event)),
                    disabled: _unref(isMukigenChecked)
                  }, null, 8, _hoisted_17), [
                    [_vModelText, _unref(date_from)]
                  ]),
                  _createTextVNode(" ~ "),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "Modal_Table_InputDate",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(date_to) ? (date_to).value = $event : date_to = $event)),
                    disabled: _unref(isMukigenChecked)
                  }, null, 8, _hoisted_18), [
                    [_vModelText, _unref(date_to)]
                  ]),
                  _createElementVNode("span", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "mukigenCheck",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isMukigenChecked) ? (isMukigenChecked).value = $event : isMukigenChecked = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _unref(isMukigenChecked)]
                    ])
                  ]),
                  (hasDateError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(dateErrorMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(BtnGreen, {
                onClick: updateST,
                style: {"margin-right":"5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("確定")
                ]),
                _: 1
              }),
              (showDeleteBtn.value)
                ? (_openBlock(), _createBlock(BtnWhite, {
                    key: 0,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (modalName.value = 'modalWarningMessage')),
                    style: {"margin-left":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("設定削除")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("button", _hoisted_23, " 設定削除 "))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})